import { v4 as uuid } from 'uuid';

import { UserRole } from 'types';

import { UserListItem } from '../../types';

export function setIdToEmailItems(list: string[]): UserListItem[] {
  return list.map((email) => ({ id: uuid(), email, role: UserRole.Employee }));
}
